


<div class="text-text flex flex-col justify-center items-center gap-2  w-full ">

    <h1 class="text-white">Centro notifiche</h1>

    <div class=" w-full flex flex-col justify-center items-center gap-2 p-4 bg-white/20 rounded-3xl" *ngIf="newNotif.length > 0">
        <h2 class="text-white">Notifiche non lette</h2>

        <div *ngFor="let n of newNotif" class="w-full">

            <div class="rounded-2xl bg-primary-500/50 backdrop-blur-3xl gap-3  user-card p-4 flex justify-between items-center m-1 text-white">
                <div class="flex flex-col justify-start"> 
                    <p class="text-xs">{{n.date |date:"dd/MM/yyy hh:mm"}}</p>
                    <p class="font-medium text-lg">{{n.content}}</p>
                </div>
                <div class="bg-red-500 rounded-full p-2" *ngIf="!n.success">
                    <svg style="color: white;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>
                <div class="bg-emerald-500 rounded-full p-2" *ngIf="n.success">
                    <svg style="color: white;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                    </svg>
                </div>
            </div>
    
            
        </div>

        

    </div>

    <h2 *ngIf="oldNotif.length > 0 && newNotif.length > 0" class="text-white">Notifiche vecchie </h2>
    <h2 *ngIf="oldNotif.length == 0" class="text-white">Nessuna notifica </h2>
    <div *ngFor="let n of oldNotif" class="w-full">

        <div class="rounded-3xl bg-primary-50/60  backdrop-blur-3xl user-card  p-4 gap-3 flex justify-between items-center m-1 ">
            <div class="flex flex-col justify-start"> 
                <p class="text-xs">{{n.date |date:"dd-MM-yyy hh:mm"}}</p>
                <p class="font-medium text-lg">{{n.content}}</p>
            </div>
            <div class="bg-red-500 rounded-full p-2" *ngIf="!n.success">
                <svg style="color: white;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </div>
            <div class="bg-emerald-500 rounded-full p-2" *ngIf="n.success">
                <svg style="color: white;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
            </div>
        </div>

        
    </div>
</div>